import {
    ChangeDetectionStrategy,
    Component,
    OnDestroy,
    OnInit,
    input,
    computed,
} from '@angular/core';
import { EntData } from '@bazis/shared/models/srv.types';
import { CommonModule } from '@angular/common';
import { AccordionModule } from '@bazis/shared/components/web/accordion/accordion.module';
import { FileInlineComponent } from '@bazis/shared/components/file/file-inline.component';
import { IconModule } from '@bazis/shared/components/web/icon/icon.module';
import { ButtonModule } from '@bazis/shared/components/web/button/button.module';
import { SafePipe } from '@bazis/shared/pipes/safe.pipe';
import { TranslocoModule } from '@jsverse/transloco';
import { ColorDirective } from '@bazis/shared/directives/color.directive';

@Component({
    selector: 'bazis-document-accordeon',
    templateUrl: './document-accordeon.component.html',
    imports: [
        AccordionModule,
        FileInlineComponent,
        ButtonModule,
        IconModule,
        SafePipe,
        TranslocoModule,
        ColorDirective,
        CommonModule,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentAccordeonComponent implements OnDestroy, OnInit {
    readonly document = input<EntData>();

    readonly isOpen = input(false);

    readonly isPdf = computed(() => {
        return this.document().$snapshot.file_upload_url.includes('.pdf');
    });

    readonly nonPdfUrl = computed(() => {
        return `https://docs.google.com/gview?url=${location.host}${this.document().$snapshot.file_upload_url}&embedded=true`;
    });

    openDropdownMenu = false;

    ngOnInit(): void {}

    ngOnDestroy(): void {}
}
